import { render, staticRenderFns } from "./RequestLogs.vue?vue&type=template&id=9b8c4aca&scoped=true&"
import script from "./RequestLogs.vue?vue&type=script&lang=js&"
export * from "./RequestLogs.vue?vue&type=script&lang=js&"
import style0 from "./RequestLogs.vue?vue&type=style&index=0&id=9b8c4aca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8c4aca",
  null
  
)

export default component.exports